import React, { Component } from "react"

import Button from "../components/Button"
import EthosIcons from "./EthosIcons"
import FullPowerProgram from "../components/FullPowerProgram"
import PowerFive from "../components/PowerFive"
import PowerProgram from "../components/PowerProgram"
import Testimonials from "../components/Testimonials"
import styles from "../styles/quiz.module.scss"
import PriceButton from "../components/PriceButton"


class MemberQuiz extends Component {
  constructor() {
    super()

    this.state = {
      cards: [
        {
          title: "Security",
          description: "taking comfort in a safety net",
          sentence:
            "A sense of certainty - knowing that you have something or someone to rely on.",
        },
        {
          title: "Health",
          description: "both in body and mind",
          sentence:
            "Flourishing in your body, sustained by nutrition, movement, and mindfulness.",
        },
        {
          title: "Wealth",
          description: "abundance both material and spiritual",
          sentence:
            "Material prosperity or plentiful supplies of a particular resource.",
        },
        {
          title: "Trust",
          description: "confidence in those you love and in yourself",
          sentence:
            "A firm belief in the reliability, truth, ability, or strength in someone or something.",
        },
        {
          title: "Adventure",
          description: "exploration and welcoming new experiences",
          sentence:
            "Curiosity and a willingness to experience something new, carried with enthusiasm.",
        },
        {
          title: "Courage",
          description: "mental and moral bravery",
          sentence:
            "A willingness and desire to step outside of your comfort zone…to be bold.",
        },
        {
          title: "Creativity",
          description: "expressing your brilliance",
          sentence:
            "To communicate your ideas through various mediums that speak most to you and your brilliance.",
        },
        {
          title: "Respect",
          description: "admiration and appreciation of the world",
          sentence:
            "A high level of gratitude and recognition for someone or something.",
        },
        {
          title: "Authenticity",
          description: "being true and genuine to yourself",
          sentence:
            "Sharing your truth, speaking, and living from your heart. Being genuine.",
        },
        {
          title: "Love",
          description: "devotion, admiration, and affection",
          sentence:
            "A positive force that is felt deep in the soul that can be expressed as a noun, a verb, and an emotion.",
        },
        {
          title: "Family",
          description:
            "standing alongside and behind those with whom you are truly connected with",
          sentence: "A group of individuals who are connected at the heart.",
        },
        {
          title: "Honesty",
          description: "acting on the truth through integrity, always",
          sentence: "Being willing to speak and act on the facts.",
        },
        {
          title: "Loyalty",
          description: "unwavering allegiance",
          sentence:
            "Steadfast dedication to something or someone you truly believe in.",
        },
        {
          title: "Compassion",
          description: "the desire to alleviate and understand another’s pain",
          sentence:
            "An understanding, that is sponsored with love of another person’s journey, pain, or challenge.",
        },
        {
          title: "Friendship",
          description: "the value of companionship and shared experiences",
          sentence:
            "A fellowship, a bond based in shared adventures, a desire to “do life” together, and watch each other flourish.",
        },
        {
          title: "Growth",
          description: "always reaching for new ways of moving forward",
          sentence:
            "Expanding into a new dimension of understanding, experience, or knowledge.",
        },
        {
          title: "Excellence",
          description: "having and sticking to high standards",
          sentence:
            "Possessing lofty morals, and being responsible and accountable when moving through life.",
        },
        {
          title: "Determination",
          description: "unwavering focus to achieve the desired goal",
          sentence:
            "A dependable concentration necessary to achieve the ultimate objective.",
        },
        {
          title: "Independence",
          description: "standing on your own, in your own truth",
          sentence:
            "Knowing yourself, thinking freely, and acting upon your morals.",
        },
        {
          title: "Religion",
          description: "devotion to your beliefs and commitments",
          sentence: "Having faith or observing a higher power.",
        },
        {
          title: "Wisdom",
          description:
            "mindfully passing on what you’ve learned, and continuing to listen",
          sentence:
            "To hold a deep understanding of the world around you and to be able to communicate and teach others what you know.",
        },
        {
          title: "Spirituality",
          description: "the belief in something larger than yourself",
          sentence: "Valuing the idea of immateriality. ",
        },
        {
          title: "Ambition",
          description: "the inner drive to reach your goals",
          sentence: "The desire to achieve a particular end.",
        },
        {
          title: "Equality",
          description: "always treating others the way you want to be treated",
          sentence: "Knowing that everyone has a place in this world.",
        },
        {
          title: "Justice",
          description: "putting equal treatment above all",
          sentence: "Treating others as you would want to be treated.",
        },
        {
          title: "Teamwork",
          description:
            "empowering others and using their strengths toward a common goal",
          sentence:
            "The combined action of a group of people to accomplish a desired outcome.",
        },
        {
          title: "Helpfulness",
          description:
            "always providing what you can, where you can, whenever you can",
          sentence: "Assisting and aiding whoever needs it.",
        },
        {
          title: "Freedom",
          description: "valuing the opportunity of choice",
          sentence:
            "The absence of necessity, coercion, or restraint in choice or action.",
        },
        {
          title: "Spontaneity",
          description:
            "acting on the unexpected impulse coming from a place of joy",
          sentence:
            "Going out on an unexpected whim, usually sponsored by happiness.",
        },
        {
          title: "Joy",
          description:
            "coming from a state of unbridled bliss and a positive attitude",
          sentence:
            "Uncontrolled happiness and euphoria that brings a sense of feeling good about your place in the world.",
        },
        {
          title: "Empowerment",
          description:
            "the process that fosters power in lives, community, and society",
          sentence:
            "My soul’s purpose: to feel em•powered and em•power others.",
        },
        {
          title: "Connection",
          description: "being open and available to another person",
          sentence:
            "Remembering that we all have a story, and when we share our stories we are reminded that we are more alike than we are different.",
        },
        {
          title: "Certainty",
          description: "fixed, settled, indisputable",
          sentence: "A knowingness that is undeniable.",
        },
        {
          title: "Intuition",
          description: "the ability to truly understand something",
          sentence:
            "Trusting your core without the need for conscious reasoning; the inner voice that gives you guidance.",
        },
        {
          title: "Peace",
          description: "freedom from disturbance, tranquility",
          sentence: "Having a sense and experience of calm and restfulness.",
        },
        {
          title: "Discipline",
          description:
            "activity, exercise, or training regimen that develops or improves a skill",
          sentence: "Harnessed and focused willpower to achieve a goal.",
        },
        {
          title: "Tradition",
          description:
            "an inherited, established, or customary pattern of thought, action, or behavior",
          sentence:
            "Practices, thoughts, ideas, and events that hold meaning and are repeated.",
        },
        {
          title: "Privacy",
          description: "the state of being free from public attention",
          sentence: "Keeping to one’s self.",
        },
        {
          title: "Accountability",
          description: "taking responsibility for one’s actions",
          sentence: "Fully owning your choices, actions, words.",
        },
        {
          title: "Challenge",
          description: "a call to take part in a contest or competition",
          sentence:
            "Something that pushes us to go beyond what we thought possible.",
        },
        {
          title: "Variety",
          description:
            "Diversity leading to the absence of uniformity or monotony",
          sentence: "Having a multitude of choices.",
        },
        {
          title: "Excitement",
          description: "a feeling of great enthusiasm and eagerness",
          sentence: "A feeling of readiness for something that is coming.",
        },
        {
          title: "Curiosity",
          description: "a strong desire to learn or know something",
          sentence:
            "A deep need to understand, to appreciate, and look at something with “new eyes.”",
        },
        {
          title: "Reputation",
          description: "beliefs or opinions about someone or something",
          sentence: "An impression or imprint you are leaving.",
        },
        {
          title: "Authority",
          description: "command thought, opinion, or behavior",
          sentence: "To have influence.",
        },
        {
          title: "Fame",
          description: "the state of being known or talked about",
          sentence:
            "Others overt appreciation and awareness of your public efforts and notable achievements.",
        },
        {
          title: "Beauty",
          description: "combination of qualities that’s aesthetically pleasing",
          sentence:
            "Seeing love in form; experiencing  an internal sense of joy by appreciating that which is all around you.",
        },
        {
          title: "Appreciation",
          description: "recognizing and appreciating one’s good qualities",
          sentence: "An expression of gratitude for those around you.",
        },
        {
          title: "Acceptance",
          description: "the act of taking or receiving something offered",
          sentence:
            "Being at peace internally or realizing the truth of something or someone.",
        },
        {
          title: "Influence",
          description: "the power to change or affect someone or something",
          sentence:
            "The ability to lead with grace and heart; to have a powerful impact on others.",
        },
        {
          title: "Uniqueness",
          description: "the quality of being one-of-a-kind",
          sentence: "The things, the characteristics that make you, you.",
        },
        {
          title: "Forgiveness",
          description: "to cease to feel resentment",
          sentence: "To let go.",
        },
        {
          title: "Passion",
          description:
            "strong enthusiasm or excitement for someone or doing something",
          sentence:
            "Having a strong conviction that yields the emotions of excitement, purpose, joy, and love.",
        },
        {
          title: "Success",
          description: "the accomplishment of an aim or purpose",
          sentence: "Achieving a goal or a desired outcome.",
        },
        {
          title: "Intelligence",
          description: "the ability to acquire and apply knowledge and skills",
          sentence:
            "Taking in, processing, and applying acquired knowledge, wisdom, and skills.",
        },
        {
          title: "Competence",
          description:
            "the ability to do something successfully or efficiently",
          sentence:
            "Having the ability to understand and process information or situations.",
        },
        {
          title: "Inner Harmony",
          description: "peace of mind and self-acceptance",
          sentence:
            "A dynamic and pleasant balance of the mind, body, spirit and life; acceptance of the past and life in general.",
        },
        {
          title: "Contribution",
          description: "the giving or supplying of something",
          sentence:
            "Adding value to a situation, an experience, a moment, or to someone.",
        },
        {
          title: "Meaningful Work",
          description:
            "the authentic connection between our labors and life’s purpose",
          sentence:
            "Expressing, sharing, and living your true purpose, your passion that leaves a positive legacy.",
        },
        {
          title: "Tolerance",
          description:
            "compassion and understanding for things and people different from you",
          sentence:
            "A fair, objective, and permissive attitude toward opinions, beliefs, and practices that differ from one’s own.",
        },
        {
          title: "Commitment",
          description: "the state or quality of being dedicated to a cause",
          sentence:
            "Unwavering focus and determination toward a goal, a cause, a person, or experience.",
        },
        {
          title: "Ethics",
          description: "moral principles that govern a person's behavior",
          sentence: "Your moral compass; your internal True North.",
        },
      ],
      buttonShow: true,
      cardsSubmitted: false,
      firstTen: [],
      finalSet: [],
      submitted: false,
      formSubmitted: false,
      compareArray: [],
      answer: [],
      compareSubArray: false,
      count: 0,
      finishedSorting: false,
      email: "",
      lastName:"",
      name:"",
      postSuccessful:false
    }

  }

  //Add card
  addCard(e, i) {
    e.currentTarget.className = `${styles.card} ${styles.selected}`
    this.setState({ firstTen: [e.currentTarget, ...this.state.firstTen] })
  }

  //Remove Card
  removeCard(e) {
    this.setState({
      firstTen: this.state.firstTen.filter(card => card !== e),
    })
  }

  //Toggle Card when clicked
  toggleSelected = e => {
    if (
      this.state.firstTen.length <= 9 &&
      !this.state.firstTen.includes(e.currentTarget)
    ) {
      this.addCard(e)
    } else {
      e.currentTarget.className = styles.card
      this.removeCard(e.currentTarget)
    }
  }

  //Update counter for number of cards
  async updateCount() {
    this.setState(state => {
      return {
        count: this.state.count - 1,
      }
    })
  }

  //Display Progress Bar for selecting initial 10
  displayProgressBar() {
    this.setState({
      formSubmitted: true,
    })
  }

  //Decide what to do with card once clicked on
  async selectCard(card) {
    //Get card selected and the one not selected
    let lowerCard = this.state.compareArray.filter(item => item !== card)
    let higherCard = this.state.compareArray.filter(item => item === card)
    //Filter out card not selected from array
    let tempArr = this.state.firstTen.filter(item => item != lowerCard[0])
    let length = this.state.finalSet.length
    //Set state to keep count
    this.setState({
      count: length - 1,
    })

    //Get top 5
    if (this.state.firstTen.length == 1) {
      if (
        this.state.finalSet.indexOf(higherCard[0]) >
        this.state.finalSet.indexOf(lowerCard[0])
      ) {
        let finalFive = this.state.finalSet.slice(5)
        let answer = finalFive.reverse()
        this.setState({
          finishedSorting: true,
          finalSet: [...this.state.firstTen, ...answer],
          five: answer
        })

        this.retrieve(answer)
      } else {
        //If lower card is selected, swap cards and compare lower card to next card in array
        await this.updateCount()
        let trimmedArr = this.state.finalSet.slice(0, this.state.count)
        let switchArr = this.state.finalSet
        ;[
          switchArr[switchArr.indexOf(lowerCard[0])],
          switchArr[switchArr.indexOf(higherCard[0])],
        ] = [
          switchArr[switchArr.indexOf(higherCard[0])],
          switchArr[switchArr.indexOf(lowerCard[0])],
        ]
        this.setState(
          {
            finalSet: [...switchArr],
            answer: [...trimmedArr, ...lowerCard],
            firstTen: [...tempArr],
          },
          () => {
            this.sortAnswer(lowerCard, card)
          }
        )
      }
    } else if (
      this.state.finalSet.length >= 9 &&
      this.state.firstTen.length <= 2
    ) {
      let finalFive = this.state.finalSet.slice(5)
      let answer = finalFive.reverse()
      this.setState({
        finishedSorting: true,
        finalSet: [...this.state.firstTen, ...answer],
      })
    } else if (this.state.finalSet.length >= 3) {
      //If higher card is selected, end comparison of sorted cards
      if (
        this.state.finalSet.indexOf(higherCard[0]) >
        this.state.finalSet.indexOf(lowerCard[0])
      ) {
        this.setState(
          {
            finalSet: [],
            answer: [...this.state.finalSet],
            firstTen: [...tempArr],
          },
          () => {
            this.sortAnswer(lowerCard, card)
          }
        )
      } else {
        //If lower card is selected, swap cards and compare lower card to next card in array
        await this.updateCount()
        let trimmedArr = this.state.finalSet.slice(0, this.state.count)
        let switchArr = this.state.finalSet
        ;[
          switchArr[switchArr.indexOf(lowerCard[0])],
          switchArr[switchArr.indexOf(higherCard[0])],
        ] = [
          switchArr[switchArr.indexOf(higherCard[0])],
          switchArr[switchArr.indexOf(lowerCard[0])],
        ]
        this.setState(
          {
            finalSet: [...switchArr],
            answer: [...trimmedArr, ...lowerCard],
            firstTen: [...tempArr],
          },
          () => {
            this.sortAnswer(lowerCard, card)
          }
        )
      }
    } else {
      this.setState(
        {
          finalSet: [
            ...this.state.answer,
            ...lowerCard,
            ...this.state.finalSet,
          ],
          answer: [],
          firstTen: [...tempArr],
        },
        () => {
          this.sortAnswer(lowerCard, card)
        }
      )
    }
  }



  retrieve(answer){
    const params = new URLSearchParams(window.location.search)
    const userID = params.get('userID')
    console.log(userID)
    var WPAPI = require("wpapi")
    var wp = new WPAPI({
      endpoint: "https://member.empowerofyou.com/wp-json",
      // Login Info
      username: "rhino_dev",
      password: "WH2t 0p6F Hyew OX2L LeTr oE8B",
    })
  
  
    wp.users().id(userID)
      .update({
     
        meta: {
          ethos1: this.state.firstTen[0].childNodes[0].innerHTML,
          definition1: this.state.firstTen[0].childNodes[1].innerHTML,
          sentence1: this.state.firstTen[0].childNodes[2].innerHTML.replaceAll("\"", ""),
          ethos2: answer[0].firstChild.innerHTML,
          definition2: answer[0].childNodes[1].innerHTML,
          sentence2: answer[0].childNodes[2].innerHTML.replaceAll("\"", ""),
          ethos3: answer[1].firstChild.innerHTML,
          definition3: answer[1].childNodes[1].innerHTML,
          sentence3: answer[1].childNodes[2].innerHTML.replaceAll("\"", ""),
          ethos4: answer[2].firstChild.innerHTML,
          definition4: answer[2].childNodes[1].innerHTML,
          sentence4: answer[2].childNodes[2].innerHTML.replaceAll("\"", ""),
          ethos5: answer[3].firstChild.innerHTML,
          definition5: answer[3].childNodes[1].innerHTML,
          sentence5: answer[3].childNodes[2].innerHTML.replaceAll("\"", ""),
        },
        status: "publish",
      })
  
      .then((response)=> console.log(response.id))

      .then(()=>{setTimeout(function(){
        this.setState({
          postSuccessful:true
        });
   }.bind(this),3000); })

   
  }

  sortAnswer() {
    if (this.state.answer.length >= 2 && this.state.finalSet.length >= 3) {
      this.answerSort(this.state.answer)
    } else if (this.state.finalSet.length >= 3) {
      this.shuffleCards(this.state.firstTen)
      this.answerSort(this.state.finalSet)
    } else {
      this.insertionSort(this.state.firstTen)
    }
  }

  //Shuffle remaining cards after sorting
  shuffleCards(cards) {
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[cards[i], cards[j]] = [cards[j], cards[i]]
    }
    return cards
  }

  //Sort array of already sorted cards
  answerSort(array) {
    let tempArray = [...array]
    let compareArray
    let length = tempArray.length

    //Select last two of array to compare
    let first = tempArray[length - 1]
    let second = tempArray[length - 2]
    compareArray = [second, first]

    this.setState({
      compareArray: [...compareArray],
    })
  }

  //Sort the initial 10
  insertionSort(array) {
    this.setState({
      cardsSubmitted: true,
    })

    let tempArray = [...array]
    let compareArray

    //Selects first two element of array to compare
    let first = tempArray[0]
    let second = tempArray[1]
    compareArray = [first, second]

    this.setState({
      compareArray: [...compareArray],
    })
  }

  //Next button after selecting initial 10
  handleNext(array) {
    window.scrollTo(0, 0)
    this.setState({ submitted: true })
    this.insertionSort(array)
  }

  render() {
    const {
      cardsShow,
      answer,
      buttonShow,
      cardsSubmitted,
      formSubmitted,
      postSuccessful,
      firstTen,
      cards,
      compareArray,
      finalSet,
      finishedSorting,
    } = this.state

    return (
      <>
        {!cardsSubmitted ? (
          <>
           
              <div className={styles.quizProgress}>
                <div className={styles.quizProgress_bar}>
                  <div
                    className={
                      firstTen.length >= 1
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 2
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 3
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 4
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 5
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 6
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 7
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 8
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 9
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                  <div
                    className={
                      firstTen.length >= 10
                        ? styles.filledSquare
                        : styles.progressSquare
                    }
                  />
                </div>
                {firstTen.length == 10 && compareArray.length < 2 ? (
                  <Button
                    label="Next Step"
                    backgroundColor="#9FE5E3"
                    onClick={() => {
                      this.handleNext(firstTen)
                      this.props.handleNext()
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
           
          </>
        ) : (
          ""
        )}

        {finishedSorting ? (
          <>
            <div className={styles.finalFive_outer}>
              <div className={styles.finalFive}>
                <div className={styles.intro_img}>
                  <iframe
                    src="https://player.vimeo.com/video/476506181"
                    width="640"
                    height="360"
                    frameborder="0"
                    width="700"
                    height="564"
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                  ></iframe>
                </div>
                <div className={styles.powerFive}>
      <div className={styles.powerFive_inner}>
        <div className={styles.powerFive_inner_txt}>
          <h2>
            You have now discovered <span className={styles.blue}>YOUR</span>{" "}
            “Power Five,” the Ethos which make you, <span className={styles.blue}>YOU</span>!
          </h2>
          <p>
            <span className={styles.blue}>What’s Next?</span> Learn how to harness
            and apply the power of YOUR Ethos to achieving your goals in life,
            health, business and beyond!
          </p>
        </div>
      </div>
    </div>
                {/* <h2 className={styles.finalFive_heading}>You have reached your ethos manifest.</h2> */}
              </div>
              <div className={styles.cards}>
                {finalSet.map((card, i) => (
                  <div className={styles.final_card} key={i}>
                    <h2 className={styles.card__title}>
                      {card.children[0].innerText}
                    </h2>
                    <p className={styles.card__description}>
                      {card.children[1].innerText}
                    </p>
                    <p className={styles.card__sentence}>
                      {card.children[2].innerText}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            {postSuccessful ? (
          <div className={styles.memberButton}>
            <Button href={'https://member.empowerofyou.com/'} backgroundColor={'#ffbe76'} label={'Access Your Account'}/>
          </div>):''}
          </>
        ) : (
          <div>
            {cardsSubmitted ? (
              <>
                <div className={styles.compare}>
                  <div className={styles.compareTxt}>
                    <h2>
                      Now let’s hone in on
                      <span className={styles.your}> YOUR</span> ethos
                    </h2>
                    <p>Which one means more to you?</p>
                    <p>Choose between these two cards</p>
                  </div>
                  <div className={styles.cards_outer}>
                    <div className={styles.cards}>
                      {compareArray.map((card, i) => (
                        <div
                          className={styles.card}
                          key={i}
                          onClick={() => this.selectCard(card)}
                        >
                          <h2 className={styles.card__title}>
                            {card.children[0].innerText}
                          </h2>
                          <p className={styles.card__description}>
                            {card.children[1].innerText}
                          </p>
                          <p className={styles.card__sentence}>
                            {card.children[2].innerText}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className={styles.sortProgress}>
                  <div className={styles.sortProgress_bar}>
                    <div
                      className={
                        finalSet.length >= 1 || answer.length >= 1
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 2 || answer.length >= 2
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 3 || answer.length >= 3
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 4 || answer.length >= 4
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 5 || answer.length >= 5
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 6 || answer.length >= 6
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 7 || answer.length >= 7
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 8 || answer.length >= 8
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 9 || answer.length >= 9
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                    <div
                      className={
                        finalSet.length >= 10 || answer.length >= 10
                          ? styles.filledSquare
                          : styles.progressSquare
                      }
                    />
                  </div>
                </div>
              </>
            ) : (
              <div>
                <>
                
                    <div className={styles.intro_img}>
                      <iframe
                        src="https://player.vimeo.com/video/476506088?title=0&byline=0&portrait=0"
                        width="640"
                        height="360"
                        frameborder="0"
                        width="700"
                        height="564"
                        frameBorder="0"
                        allow="autoplay; fullscreen"
                      ></iframe>
                    </div>
                  
                  <div className={styles.chooseTenHeading}>
                    <h2>Choose the values that ground you.</h2>
                    <h3>Select your top 10 ethos cards.</h3>
                  </div>
                  <div className={styles.cards}>
                    {cards.map((card, i) => (
                      <div
                        className={styles.card}
                        key={i}
                        onClick={(e, i) => {
                          this.toggleSelected(e)
                        }}
                      >
                        <h2 className={styles.card__title}>{card.title}</h2>
                        <p className={styles.card__description}>
                          {card.description}
                        </p>
                        <p
                          className={styles.card__sentence}
                          style={{ display: "none" }}
                        >
                          "{card.sentence}"
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              </div>
            )}
          </div>
        )}
      </>
    )
  }
}
export default MemberQuiz
